import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Alert,
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120vs1065 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="Form 1120-S vs 1065: Key Differences & Filing Guide"
          description="Compare IRS Forms 1120-S and 1065. Learn how S Corps and Partnerships differ in taxes, ownership, and filing to choose the right structure for your business."
          keywords=""
          canonical="resources/business-tax/form-1120s-vs-form-1065-comparison/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          <span className="highlight-container">
            <span className="highlight">Form 1120-S</span>
          </span>{' '}
          vs.{' '}
          <span className="highlight-container">
            <span className="highlight">Form 1065</span>
          </span>
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/form-1120s-vs-form-1065-comparison/"
                  />

                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    variant="h4"
                    itemProp="headline"
                    sx={{
                      fontWeight: 600,
                      mb: 2,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Form 1120-S vs. Form 1065 at a Glance
                  </Typography>

                  <Typography variant="body1" sx={{ mb: 2 }}>
                    <span style={{ fontWeight: 600 }}>Form 1120-S</span> is
                    generally filed by eligible{' '}
                    <span style={{ fontWeight: 600 }}>S corporations</span>,
                    while <span style={{ fontWeight: 600 }}>Form 1065</span> is
                    filed by{' '}
                    <span style={{ fontWeight: 600 }}>
                      partnerships and LLCs taxed as partnerships
                    </span>
                    . Both are pass-through tax returns, but their ownership,
                    compensation, and tax rules differ.
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>Form 1120-S:</span>{' '}
                        Used by eligible S corporations. Income, deductions, and
                        credits generally{' '}
                        <span style={{ fontWeight: 600 }}>
                          pass through to shareholders
                        </span>
                        , who receive Schedule K-1.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>Form 1065:</span> Used
                        by partnerships and qualifying multi-member LLCs.
                        Partnership income, deductions, and credits generally{' '}
                        <span style={{ fontWeight: 600 }}>
                          pass through to partners
                        </span>
                        , who receive Schedule K-1.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>Ownership:</span> S
                        corporations generally have a{' '}
                        <span style={{ fontWeight: 600 }}>
                          100-shareholder limit
                        </span>{' '}
                        and restrictions on eligible shareholders and stock
                        classes. Partnerships generally have{' '}
                        <span style={{ fontWeight: 600 }}>
                          more flexible ownership rules
                        </span>
                        .
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <span style={{ fontWeight: 600 }}>
                          Which Form to File:
                        </span>{' '}
                        The correct form depends primarily on the business's{' '}
                        <span style={{ fontWeight: 600 }}>
                          legal structure, tax election, ownership, and
                          applicable IRS requirements
                        </span>
                        .
                      </span>
                    </li>
                  </Box>
                </Box>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Choosing between{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 1120-S
                  </Link>{' '}
                  and{' '}
                  <Link
                    href="https://www.irs.gov/forms-pubs/about-form-1065"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 1065
                  </Link>{' '}
                  depends on how your business is organized and taxed. Both
                  forms report pass-through income to business owners, but they
                  differ in ownership rules, compensation, self-employment
                  taxes, and filing requirements.
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  This guide compares{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    IRS Form 1120-S vs Form 1065,
                  </strong>{' '}
                  explains when each form is required, and helps you determine
                  which return your business should file.
                </Typography>
                <Box sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }} />

                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#corporation" sx={{ color: '#0202ff' }}>
                          S Corporation vs Partnership
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#major" sx={{ color: '#0202ff' }}>
                          Major Differences Between Form 1120-S and Form 1065
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#eligibility" sx={{ color: '#0202ff' }}>
                          Eligibility Requirements
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#comparing" sx={{ color: '#0202ff' }}>
                          Comparing Tax Treatment for S Corporations and
                          Partnerships
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#reporting" sx={{ color: '#0202ff' }}>
                          Reporting and Filing Requirements
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#which" sx={{ color: '#0202ff' }}>
                          Which Form Should You File?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#making" sx={{ color: '#0202ff' }}>
                          Making the Right Filing Choice for Your Business
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="corporation"
                >
                  S Corporation vs Partnership
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            S Corporation
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Partnership / LLC
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            <strong style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Form 1120-S
                            </strong>
                            <br />
                            Filed by{' '}
                            <strong style={{ fontWeight: 600 }}>
                              corporations or LLCs
                            </strong>{' '}
                            that have elected S Corp status via{' '}
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f2553.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 2553
                            </Link>
                            .
                            <br />
                            <Box
                              component="ul"
                              sx={{ mb: 2, '& li': { mb: 1.2 } }}
                            >
                              <li>
                                Income, losses, and credits pass through to
                                shareholders
                              </li>
                              <li>
                                Shareholders receive{' '}
                                <Link
                                  href="/resources/business-tax/schedule-k-1/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule K-1
                                </Link>{' '}
                              </li>
                              <li>
                                Shareholder-employees can draw a salary separate
                                from distributions
                              </li>
                              <li>
                                Limited to 100 shareholders, one class of stock
                              </li>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <strong style={{ fontWeight: 600, fontSize: 16 }}>
                              {' '}
                              Form 1065
                            </strong>{' '}
                            <br />
                            Filed by{' '}
                            <strong style={{ fontWeight: 600 }}>
                              {' '}
                              partnerships and multi-member LLCs
                            </strong>{' '}
                            taxed as partnerships.
                            <Box
                              component="ul"
                              sx={{ mb: 2, '& li': { mb: 1.2 } }}
                            >
                              <li>
                                Not a separate tax-paying entity; income passes
                                to partners
                              </li>
                              <li>
                                Each partner receives{' '}
                                <Link
                                  href="/resources/business-tax/schedule-m-1-form-1065/"
                                  sx={{ color: '#0202ff' }}
                                >
                                  {' '}
                                  Schedule K-1
                                </Link>{' '}
                              </li>
                              <li>Partners are self-employed, not employees</li>
                              <li>
                                No restrictions on number or type of owners
                              </li>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="major"
                >
                  Major Differences Between Form 1120-S and Form 1065
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 100, fontWeight: 600 }}
                          >
                            Feature
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Form 1120-S (S Corporation)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Form 1065 (Partnership/LLC)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>Who Files </TableCell>
                          <TableCell>S Corporations</TableCell>
                          <TableCell>
                            Partnerships & multi-member LLCs
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Taxation </TableCell>
                          <TableCell>
                            Pass-through; shareholders report income
                          </TableCell>
                          <TableCell>
                            Pass-through; partners report income
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Self-Employment Taxes </TableCell>
                          <TableCell>
                            Salary subject to payroll tax; distributions not
                          </TableCell>
                          <TableCell>
                            Entire share generally subject to self-employment
                            tax{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Compensation Rules </TableCell>
                          <TableCell>Shareholders can be employees</TableCell>
                          <TableCell>Partners cannot be employees</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Profit Distribution </TableCell>
                          <TableCell>
                            Must follow ownership percentages{' '}
                          </TableCell>
                          <TableCell>
                            Flexible distribution arrangements
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Filing Requirements </TableCell>
                          <TableCell>
                            Form 1120-S + Schedule K-1 for each shareholder
                          </TableCell>
                          <TableCell>
                            Form 1065 + Schedule K-1 for each partner
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Ownership Restrictions </TableCell>
                          <TableCell>
                            ‰¤100 shareholders; only individuals, certain
                            trusts/estates; U.S. persons only{' '}
                          </TableCell>
                          <TableCell>
                            No restrictions on number or type of owners{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>Due Date </TableCell>
                          <TableCell>
                            March 15 (or 2.5 months after year-end)
                          </TableCell>
                          <TableCell>
                            March 15 (or 2.5 months after year-end)
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>Complexity </TableCell>
                          <TableCell>More compliance & IRS rules </TableCell>
                          <TableCell>
                            Simpler structure, flexible agreements{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{ mt: 0, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
                  id="filing"
                >
                  <b>Note :</b> Refer our{' '}
                  <Link
                    href="/resources/business-tax/form-1120-s-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120 S Instructions
                  </Link>{' '}
                  and the{' '}
                  <Link
                    href="/resources/business-tax/form-1065-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    Instructions for IRS Form 1065
                  </Link>{' '}
                  for detailed guidance.
                </Alert>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="eligibility"
                >
                  Eligibility Requirements
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            To file Form 1120-S
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            To file Form 1065
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            <Box
                              component="ul"
                              sx={{ mb: 0, '& li': { mb: 1.2 } }}
                            >
                              <li>
                                Must be a domestic corporation or LLC that
                                elected corporate taxation
                              </li>
                              <li>Limited to 100 shareholders</li>
                              <li>Only one class of stock allowed</li>
                              <li>
                                Shareholders must be U.S. citizens or residents
                                and not partnerships, corporations, or
                                non-resident aliens
                              </li>
                              <li>
                                Must have filed Form 2553 to elect S status
                              </li>
                            </Box>
                          </TableCell>
                          <TableCell>
                            <Box
                              component="ul"
                              sx={{ mb: 0, '& li': { mb: 1.2 } }}
                            >
                              <li>
                                Must be a domestic or foreign partnership with
                                two or more members
                              </li>
                              <li>
                                No restrictions on ownership: individuals,
                                corporations, foreign persons, or entities all
                                qualify
                              </li>
                              <li>
                                Flexible partnership agreements allow customised
                                profit allocations
                              </li>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="comparing"
                >
                  Comparing Tax Treatment for S Corporations and Partnerships
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Tax Treatment
                          </TableCell>

                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Form 1120-S (S Corporation)
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Form 1065 (Partnership)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Compensation
                          </TableCell>
                          <TableCell>
                            Shareholder employees receive a salary.
                          </TableCell>
                          <TableCell>
                            Partners receive guaranteed payments or profit
                            distributions.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Payroll Taxes
                          </TableCell>
                          <TableCell>
                            Salaries are subject to payroll taxes.
                          </TableCell>
                          <TableCell>
                            Partners are generally not subject to payroll taxes.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Self-Employment Tax{' '}
                          </TableCell>
                          <TableCell>
                            Distributions are generally not subject to
                            self-employment tax.
                          </TableCell>
                          <TableCell>
                            General partners generally pay self-employment taxes
                            on business income.
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Tax Advantage
                          </TableCell>
                          <TableCell>
                            Salary and distribution may reduce self-employment
                            tax.
                          </TableCell>
                          <TableCell>
                            Business income is generally subject to
                            self-employment tax.
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="reporting"
                >
                  Reporting and Filing Requirements
                </Typography>

                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            For S-Corporations
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            For Partnerships
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            <Link
                              href="/business-tax/efile-irs-form-1120-s/"
                              sx={{ color: '#0202ff' }}
                            >
                              File Form 1120-S
                            </Link>{' '}
                            annually{' '}
                          </TableCell>
                          <TableCell>
                            <Link
                              href="/business-tax/efile-irs-form-1065-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              File Form 1065
                            </Link>{' '}
                            annually
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Provide each shareholder a Schedule K-1
                          </TableCell>
                          <TableCell>
                            Provide each partner a Schedule K-1
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            May also need to file state corporate returns,
                            depending on jurisdiction
                          </TableCell>
                          <TableCell>
                            Partners include their share on{' '}
                            <Link
                              href="https://www.irs.gov/pub/irs-pdf/f1040.pdf"
                              target="_blank"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 1040
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 20, sm: 18, xs: 16 },
                    mb: 0.5,
                    fontWeight: 600,
                  }}
                >
                  Original Filing Deadline
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  March 15
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    For calendar-year businesses,{' '}
                    <strong style={{ fontWeight: 600 }}> Form 1120-S</strong>{' '}
                    and <strong style={{ fontWeight: 600 }}>Form 1065</strong>{' '}
                    (or the next business day if it falls on a weekend or
                    holiday).
                  </li>
                  <li>
                    Fiscal-year filers must file by the{' '}
                    <strong style={{ fontWeight: 600 }}>
                      {' '}
                      15th day of the third month
                    </strong>{' '}
                    after their tax year ends.
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="which"
                >
                  Which Form Should You File?
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Choose Form 1120-S if…
                          </TableCell>
                          <TableCell
                            sx={{
                              color: '#444',
                              width: 300,
                              fontWeight: 600,
                              fontSize: 16,
                            }}
                          >
                            Choose Form 1065 if…
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            You qualify as an S corporation.
                          </TableCell>
                          <TableCell>
                            You operate as a partnership or multi-member LLC
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            You want to reduce self-employment taxes by
                            splitting compensation into salary and distributions
                          </TableCell>
                          <TableCell>
                            You want flexibility in how profits are allocated
                            among owners
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Your ownership is limited to U.S. persons and fits
                            within IRS restrictions
                          </TableCell>
                          <TableCell>
                            You don't want restrictions on who can hold
                            ownership
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 1,
                    scrollMarginTop: 83,
                  }}
                  id="making"
                >
                  Making the Right Filing Choice for Your Business
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  Both{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Form 1120-S and Form 1065
                  </span>{' '}
                  are used for pass-through taxation, but they differ in
                  structure, ownership rules, and how income is taxed.
                  Partnerships (Form 1065) are simpler and more flexible, while
                  S Corporations (Form 1120-S) often provide tax savings through
                  payroll and distribution strategies.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Choosing the right filing depends on your{' '}
                  <span style={{ fontWeight: 600 }}>
                    business structure, ownership goals, and tax planning
                    strategy.
                  </span>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              File Your Business Tax Return with Confidence
            </Typography>
            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Built-in checks, automatic K-1 generation, and secure submission
              for both forms.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120svs1065`}
              >
                E-file Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120vs1065;
